/**
 * Returns true when both Datadog RUM tokens are present AND the runtime
 * is not in development mode. Pulled out of `index.tsx` so the gate is
 * named and unit-testable in isolation — the concern is that a future
 * refactor could silently drop one of the AND clauses (thinking it's
 * redundant) and start sending dev telemetry to production RUM, or
 * skip init entirely when one token is misconfigured.
 */
export function shouldInitObservability({
  nodeEnv,
  applicationId,
  clientToken,
}: {
  nodeEnv: string | undefined;
  applicationId: string;
  clientToken: string;
}): boolean {
  if (nodeEnv === "development") {
    return false;
  }
  if (!applicationId || !clientToken) {
    return false;
  }
  return true;
}
